import { render, staticRenderFns } from "./template-detail.vue?vue&type=template&id=419a52c1&scoped=true&"
import script from "./template-detail.vue?vue&type=script&lang=js&"
export * from "./template-detail.vue?vue&type=script&lang=js&"
import style0 from "./template-detail.vue?vue&type=style&index=0&id=419a52c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419a52c1",
  null
  
)

export default component.exports